import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import "./homePageButton.css";

const HomepageButton = ({ text, className }) => (
  <Button
    className={`home-page-button ${className}`}
    variant="contained"
    color="secondary"
  >
    {text}
  </Button>
);

HomepageButton.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default HomepageButton;



// WEBPACK FOOTER //
// ./src/components/common/HomepageButton/HomepageButton.jsx